/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ig-drop-down{display:block;position:relative;z-index:9}ig-drop-down .drop-down-container{position:absolute;visibility:hidden;border:1px solid #ccc;border-radius:4px;background:#fff;white-space:nowrap;width:100%}ig-drop-down .drop-down-container.show{visibility:visible}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/drop.down.component.scss.ngstyle.js.pre-build-optimizer.js